import type { ReactNode } from 'react';

import useStyles from './SelectableCard.styles';

interface SelectableCardProps {
  isSelected: boolean;
  children: ReactNode;
  name: string;
  value: string;
  onSelect: () => void;
  onHover?: (id: string, isEntering: boolean) => void;
  increasePadding?: boolean;
  ariaLabel?: string;
}

const SelectableCard = ({
  isSelected,
  children,
  increasePadding = false,
  name,
  value,
  onSelect,
  onHover,
  ariaLabel,
}: SelectableCardProps) => {
  const { classes, cx } = useStyles({ increasePadding });

  return (
    <label
      className={cx(classes.selectableCard, isSelected && classes.selected)}
      onMouseEnter={() => onHover?.(value, true)}
      onMouseLeave={() => onHover?.(value, false)}
    >
      <input
        type='radio'
        name={name}
        value={value}
        checked={isSelected}
        onChange={onSelect}
        className={classes.srOnly}
        aria-label={ariaLabel}
      />
      {children}
    </label>
  );
};

export default SelectableCard;
